import Language from './Language';

export const models = {
  Language,
};
